module.exports = __webpack_public_path__ + "img/guge.93bd8c54.png";